import { Step } from 'signup-constants/Step';
import { setFlowForACQ143 } from '../experiments/acq0143/ACQ143Utils';
import { FlowStateManager } from '../flow-management/FlowStateManager';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { trackAcq143ExposureForGooglePrompt } from '../experiments/acq0143/acq0143Tracking';
import { trackAcq145ExposureForGooglePrompt } from '../experiments/acq0145/acq145Tracking';
import { setFlowForACQ145 } from '../experiments/acq0145/ACQ145Utils';
export const setFlowAfterGoogleCredentialAuthentication = response => (dispatch, getState) => {
  const state = getState();
  const isEnrolledACQ0143Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A]);
  const isEnrolledACQ0145Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0145, [ExperimentParameterGroup.Variant_A]);
  const stepsToRemove = [...(response.email ? [Step.LandingPage] : []), Step.Verification, Step.CodeVerification, Step.Password, ...(response.firstName && response.lastName ? [Step.Name] : [])];
  if (isEnrolledACQ0143Variant) {
    dispatch(setFlowForACQ143({
      stepsToRemove
    }));
  } else if (isEnrolledACQ0145Variant) {
    dispatch(setFlowForACQ145({
      stepsToRemove
    }));
  } else {
    dispatch(FlowStateManager.removeSteps(stepsToRemove));
  }
  trackAcq143ExposureForGooglePrompt(state);
  trackAcq145ExposureForGooglePrompt(state);
};